import { Scene } from './sceneTypes';

const defaultState: Scene = {
  sceneSheet: {
    showSceneSheet: false,
    sceneSheetModel: '',
  },
  preloadDone: false,
  measurementsActive: false,
  wallResizerActive: false,
  draggingWallResizer: false,
  room: null,
  showPropping: true,
};

export default defaultState;
